import React from "react";
import { FaClock } from "react-icons/fa";
import { formatCountdown, useCountdown } from "../../hooks/useCountdown";
import { PendingPayment } from "../../services/pendingPaymentService";
import { formatRupiah } from "../../utils/formatPrice";

interface Props {
  pending: PendingPayment;
  onContinue: () => void;
  onCancel: () => void;
  cancelling?: boolean;
  onExpired?: () => void;
}

export const pendingDoctorLabel = (pending: PendingPayment) =>
  pending.doctor_name || "Dokter Umum (dipilihkan otomatis)";

const PendingPaymentCard: React.FC<Props> = ({ pending, onContinue, onCancel, cancelling, onExpired }) => {
  const remaining = useCountdown(pending.remaining_seconds);

  React.useEffect(() => {
    if (remaining === 0) onExpired?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [remaining === 0]);

  if (remaining === 0) return null;

  return (
    <div className="bg-white rounded-xl shadow border border-amber-200 overflow-hidden mb-4">
      <div className="bg-amber-50 px-4 py-2 flex items-center justify-between">
        <span className="flex items-center gap-2 text-amber-700 text-sm font-semibold">
          <FaClock /> Menunggu Pembayaran
        </span>
        <span className="text-amber-700 text-sm font-bold tabular-nums">{formatCountdown(remaining)}</span>
      </div>

      <div className="px-4 py-3 text-sm">
        <p className="text-gray-800 font-medium">Konsultasi dengan {pendingDoctorLabel(pending)}</p>
        <p className="text-gray-500 mt-1">
          {formatRupiah(pending.total)}
          {pending.payment_method ? ` · ${pending.payment_method}` : ""}
        </p>
        <p className="text-xs text-gray-400 mt-1">
          Selesaikan pembayaran sebelum waktu habis, atau batalkan untuk membuat pesanan baru.
        </p>
      </div>

      <div className="px-4 pb-4 flex gap-2">
        <button
          onClick={onCancel}
          disabled={cancelling}
          className="flex-1 border border-gray-300 text-gray-600 rounded-lg py-2 text-sm font-medium disabled:opacity-50"
        >
          {cancelling ? "Membatalkan..." : "Batalkan"}
        </button>
        <button
          onClick={onContinue}
          disabled={cancelling || !pending.payment_url}
          className="flex-1 bg-teal-500 text-white rounded-lg py-2 text-sm font-semibold disabled:opacity-50"
        >
          Lanjutkan Bayar
        </button>
      </div>
    </div>
  );
};

export default PendingPaymentCard;
